<div class="compliance-container">
  <section>
    <!-- Tabs -->
    @if (!isUserExternalSupplier) {
      <mds-button-toggle
        [checkedButton]="selectedTab"
        [multiple]="false"
        [options]="tabs"
        (change)="onSwitchView($event)"
      ></mds-button-toggle>
    }
    <!-- QUESTIONNAIRES TAB -->
    @if (selectedTab === campaignTabs.QUESTIONNAIRES) {
      <section class="row">
        @if (response.info.help_text; as helpText) {
          <section class="info">
            @if (isUserExternalSupplier) {
              <div class="info__group">
                <div class="flex">
                  <mds-icon
                    [key]="mdsIcon.QUESTION_MARK_CIRCLE"
                    [pathColors]="tertiaryColor"
                    [height]="40"
                    [width]="40"
                  ></mds-icon>
                  <h3>Provide statements for {{ response.additional_data.rsls[0].name }}</h3>
                </div>
                <p class="mk-subtitle">{{ helpText }}</p>
              </div>

              <div class="info__group">
                <h5>Partial submission</h5>
                <p class="mk-subtitle">
                  It is possible to submit a response having information only for some of your products or requested
                  regulations. That will trigger an additional questionnaire to be sent to you with the information
                  which is not yet submitted.
                </p>
              </div>
            } @else {
              @if (reviewMode) {
                <div class="info__group">
                  <div class="flex">
                    <mds-icon
                      [key]="mdsIcon.QUESTION_MARK_CIRCLE"
                      [pathColors]="tertiaryColor"
                      [height]="40"
                      [width]="40"
                    ></mds-icon>
                    <h3>Review Questionnaire Responses</h3>
                  </div>
                  <p class="mk-subtitle">
                    Review the questionnaire and either approve or reject every statement. Once all statements are
                    either approved or rejected, click the “Complete Review” button on top to finish the process.
                    Rejected items will be returned to the supplier for revision
                  </p>
                </div>
              } @else {
                <div class="info__group">
                  <div class="flex">
                    <mds-icon
                      [key]="mdsIcon.QUESTION_MARK_CIRCLE"
                      [pathColors]="tertiaryColor"
                      [height]="40"
                      [width]="40"
                    ></mds-icon>
                    <h3>No Review Required</h3>
                  </div>
                  <p class="mk-subtitle">
                    This questionnaire does not require your review. The supplier may not have submitted their response
                    yet, or the review has already been completed. If the questionnaire was not completed yet
                    ("Accepted" or "No Response from Supplier") check back once the supplier submits. Otherwise, no
                    further action is needed.
                  </p>
                </div>
              }
            }
          </section>
        }
      </section>

      <section>
        <mds-grid
          (gridReady)="onGridReady($event)"
          [minHeight]="'600px'"
          [overrides]="gridOverrides"
          [sizeColumnsToFit]="true"
          [storageKey]="'compliance-questionnaire'"
          [themeClass]="'ag-theme-material'"
          (rowSelected)="updateBulkAction()"
          (filterChanged)="updateBulkAction()"
        ></mds-grid>
      </section>
    }
    <!-- HISTORY TAB -->
    @if (selectedTab === campaignTabs.HISTORY) {
      <app-request-history class="campaign__history" [rid]="rid"></app-request-history>
    }
  </section>
</div>
